export class BuildingRegion {
	id: number;

	name: string;
	map: {url: string};
	max_capacity: number;
	reservation_threshold: number;
	status: 'ok'|'under_construction'|'closed_temporarily'|'restricted';

	reservation_rule_id: number;

	created_at: string;
	updated_at: string;

	// set by our front end app
	statusPtbr: 'Normal'|'Em reforma'|'Fechado temporariamente'|'Sob Consulta';
	full: boolean;

	static setAdditionalData(br: BuildingRegion) {
		br.full = false;
		switch(br.status) {
			case 'ok': {
				br.statusPtbr = 'Normal';
				break;
			}
			case 'under_construction': {
				br.statusPtbr = 'Em reforma';
				break;
			}
			case 'closed_temporarily': {
				br.statusPtbr = 'Fechado temporariamente';
				break;
			}
			case 'restricted': {
				br.statusPtbr = 'Sob Consulta';
			}
		}
	}
	static setArrayAdditionalData(brs: BuildingRegion[]) {
		if(!brs)
			return;
		
		for(let br of brs) {
			BuildingRegion.setAdditionalData(br);
		}
	}
}